import React from 'react';
import "bootstrap/dist/css/bootstrap.css";
import '../../assets/css/style.css';
import '../../assets/css/select-search.css';

import { Formik, Form, Field, ErrorMessage } from 'formik';
import { Redirect, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SelectSearch from 'react-select-search'

import * as api from '../../api/api';
import * as utils from '../../utils';
import * as socket from '../../socket';

class DisplayInfo extends React.Component {
    constructor(props) {
        super(props);

        let returnUrl = new URLSearchParams(this.props.location.search).get("return_url");
        if (!returnUrl) {
            returnUrl = "/displays";
        }

        if (!props.match.params.id) {
            this.state = {
                needRedirect: true,
                returnUrl: returnUrl,
            }
        }
        else {
            this.state = {
                id: Number(props.match.params.id),
                displayData: {},
                checkpoints: [],
                returnUrl: returnUrl,
                needRedirect: false
            };
        }

        this.props.updateLoader({
            loaded: false,
            message: ""
        });

        this.checkpoints = [];

        // this.handleGetSettingsFromDeviceButtonClick = this.handleGetSettingsFromDeviceButtonClick.bind(this);
    }

    componentDidMount() {

        if (!api.isUserAdmin()) {
            this.setState({
                returnUrl: "/users/permission-denied",
                needRedirect: true
            });

            return;
        }

        // получим остановки для выпадающего списка
        api.makeRequest(api.getCheckpointsDictionary()).then(
            (getCheckpointsResponse) => {

                // let checkpoints = getCheckpointsResponse.data.data.map((item, i) => {
                //     return <option key={i + 1} value={item.id.toString()}>{item.name + " (" + item.description + ")"}</option>;
                // });

                this.checkpoints = getCheckpointsResponse.data.data.map((item, i) => {
                    return (
                        {
                            name: item.name + " (" + item.description + ")",
                            value: item.id.toString()
                        }
                    );
                });

                // checkpoints.unshift(<option key={0} value="0">--Не выбрано--</option>);

                // если отображаем страничку для существующего табло - запрашиваем по нему данные

                if (this.state.id != 0) {
                    api.makeRequest(api.getDisplayDetails(this.state.id)).then(
                        (getDisplaysResponse) => {

                            // console.log(getDisplaysResponse.data.data);

                            this.setState({
                                displayData: getDisplaysResponse.data.data
                            });

                            this.props.updateLoader({
                                loaded: true
                            });
                        },
                        (error) => {
                            this.props.updateLoader({
                                loaded: true,
                                message: "Ошибка при получении информации об устройстве: " + error
                            });

                            this.setState({
                                displayData: null,
                            });
                        }
                    );
                } else {
                    this.setState({
                        displayData: {
                            id: 0,
                            description: '',
                            checkpoint_id: 0,
                            hostName: '',
                            isEnabled: false,
                            loraDevEUI: '',
                            // applySettingsImmediately: false
                        }
                    });

                    this.props.updateLoader({
                        loaded: true
                    });
                }
            },
            (error) => {

                this.props.updateLoader({
                    loaded: true,
                    message: "Ошибка при получении списка остановок: " + error
                });

                this.setState({
                    displayData: null,
                    checkpoints: null
                });
            }
        );
    }

    // handleGetSettingsFromDeviceButtonClick(setFieldValue) {

    //     this.props.updateLoader({
    //         loaded: false
    //     });

    //     api.makeRequest(api.getSettingsFromDevice(this.state.displayData)).then(
    //         (response) => {

    //             setFieldValue("settings", response.data.data)

    //             this.props.updateLoader({
    //                 loaded: true
    //             });
    //         },
    //         (error) => {
    //             this.props.updateLoader({
    //                 loaded: true,
    //                 message: "Ошибка при получении настроек от устройства: " + error
    //             });
    //         }
    //     );
    // }

    save(displayData) {
        const dataToSave = {
            description: displayData.description,
            checkpoint_id: displayData.checkpoint_id,
            hostName: displayData.hostName,
            isEnabled: displayData.isEnabled === 'true' || displayData.isEnabled === true ? true : false,
        };

        // console.log(dataToSave);

        this.props.updateLoader({
            loaded: false
        });

        api.makeRequest(api.saveDisplayData(this.state.id, dataToSave)).then(
            (response) => {

                // if (this.state.displayData.originIsEnabled != displayData.isEnabled
                //     || (displayData.id == 0 && displayData.isEnabled == 1)
                //     || this.state.displayData.origin_loraDevEUI != displayData.loraDevEUI
                // ) {
                //     socket.getInstance().emit('initMonitor', (result) => {
                //         result.success
                //             ? console.log("Повторная инициализация монитора выполнена успешно")
                //             : console.error("Ошибка повторной инициализации монитора: " + result.error);
                //     });
                // }

                this.setState({
                    needRedirect: true
                });

                this.props.updateLoader({
                    loaded: true
                });
            },
            (error) => {
                this.props.updateLoader({
                    loaded: true,
                    message: "Ошибка при сохранении: " + error
                });
            }
        )
            .catch((error) => {
                this.props.updateLoader({
                    loaded: true,
                    message: "Ошибка при сохранении: " + error
                });
            });
    }

    render() {

        if (this.state.needRedirect) {
            return <Redirect to={this.state.returnUrl} />
        }

        return (
            <div>

                <h4 className="mb-4">{this.state.id == 0 ? "Создание нового табло" : "Редактирование табло"}</h4>

                <Formik
                    initialValues={this.state.displayData}
                    //TODO: поправить
                    enableReinitialize={true}
                    //
                    validate={values => {
                        let errors = {};
                        // if (!values.name) {
                        //     errors.name = 'Пожалуйста, заполните это поле';
                        // };

                        if (!values.description) {
                            errors.description = 'Пожалуйста, заполните это поле';
                        };

                        if (!values.checkpoint_id || values.checkpoint_id == 0) {
                            errors.checkpoint_id = 'Пожалуйста, выберите существующий остановочный пункт';
                        };

                        if (!values.hostName) {
                            errors.hostName = 'Пожалуйста, заполните это поле';
                        };

                        return errors;
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                        this.save(values);
                    }}
                >
                    {({ isSubmitting, handleSubmit, values, setFieldValue }) => (
                        <Form>
                            {/* <div className="form-group">
                                <label>Название</label>
                                <Field className="form-control" type="text" name="name" />
                                <ErrorMessage className="form-error-message" name="name" component="div" />
                            </div> */}
                            <div className="form-group">
                                <label>ID</label>
                                <Field className="form-control" type="text" name="id" disabled />
                            </div>
                            <div className="form-group">
                                <label>Остановочный пункт</label>
                                {/* <Field className="form-control" name="checkpoint_id" component="select">
                                    {this.state.checkpoints}
                                </Field> */}
                                <SelectSearch className="select-search-box"
                                    options={this.checkpoints}
                                    value={values.checkpoint_id ? values.checkpoint_id.toString() : ""}
                                    mode="input"
                                    onChange={(item) => {
                                        setFieldValue("checkpoint_id", item.value)
                                    }}
                                />
                                <ErrorMessage className="form-error-message" name="checkpoint_id" component="div" />
                            </div>
                            <div className="form-group">
                                <label>Описание</label>
                                <Field className="form-control" type="text" name="description" />
                                <ErrorMessage className="form-error-message" name="description" component="div" />
                            </div>
                            <div className="form-group">
                                <label>Сетевой адрес</label>
                                <Field className="form-control" type="text" name="hostName" />
                                <ErrorMessage className="form-error-message" name="hostName" component="div" />
                            </div>
                            {/* <div className="form-group">
                                <label>IP-адрес</label>
                                <Field className="form-control" type="text" name="ipAddress" />
                                <ErrorMessage className="form-error-message" name="ipAddress" component="div" />
                            </div>
                            <div className="form-group">
                                <label>Порт</label>
                                <Field className="form-control" type="text" name="port" />
                                <ErrorMessage className="form-error-message" name="port" component="div" />
                            </div>
                            <div className="form-group">
                                <label>DevEUI модема LoRa</label>
                                <Field className="form-control" type="text" name="loraDevEUI" />
                                <ErrorMessage className="form-error-message" name="loraDevEUI" component="div" />
                            </div> */}
                            <div className="form-group">
                                <label>Включено?</label>
                                <Field className="form-control" name="isEnabled" component="select">
                                    <option value="true">Да</option>
                                    <option value="false">Нет</option>
                                </Field>
                                <ErrorMessage className="form-error-message" name="isEnabled" component="div" />
                            </div>
                            {/* <button className="btn btn-primary-custom" type="submit" disabled={isSubmitting}> */}
                            {/* <button className="btn btn-primary-custom" type="submit">
                                Сохранить
                            </button> */}

                            <div className="d-flex">
                                {/* <div className="dropdown">
                                    <button className="btn btn-primary-custom" type="button" data-toggle="dropdown">
                                        Сохранить
                                </button>
                                    <div className="dropdown-menu dropdown-menu-right">
                                        <a class="dropdown-item dropdown-item-custom" onClick={handleSubmit}>Сохранить</a>
                                        <a class="dropdown-item dropdown-item-custom" onClick={() => { values.applySettingsImmediately = true; handleSubmit() }}>Сохранить и применить настройки</a>
                                    </div>
                                </div> */}

                                <button className="btn btn-primary-custom" type="submit">
                                    Сохранить
                                </button>

                                {
                                    (!!this.state.id && this.state.id > 0) &&
                                    <button className="btn btn-secondary ml-2 btn-with-link" type="button">
                                        <Link to={"/displays/" + this.state.id + "/settings?return_url=" + "/displays/" + this.state.id + "/details"}>Изменить настройки</Link>
                                    </button>
                                }



                                <button className="btn btn-secondary ml-2 btn-with-link" type="button">
                                    <Link to={this.state.returnUrl}>Назад</Link>
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        );
    }
}

export default DisplayInfo;